import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BodyUserInformation, ResponseUserInformation } from 'src/shared/models';

@Injectable({providedIn: 'root'})

export class UserInformationService {
  constructor(private http: HttpClient) { }

  private url = `${environment.baseURL}/b/inicio`;

  Post(data:BodyUserInformation):Observable<ResponseUserInformation>{
    return this.http.post<ResponseUserInformation>(`${this.url}/informacion_usuario`, data);
  }
}
